
































import { IHasPartnerId } from "@/lib/interfaces/has-partner-id.interface";
import { IBreadcrumb } from "@/lib/interfaces/utility/breadcrumb-interface";
import { IHasUpdatePartial } from "@/lib/utility/data/has-update-partial.interface";
import { handleError } from "@/lib/utility/handleError";
import { ITicket } from "@/models/ticket.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import MHeader, { IAction, IAlert, IChips } from "../../utility/mmmint/MHeader.vue";

type IHasTitle = Pick<ITicket, "title">;
type T = IHasTitle & IHasPartnerId;

@Component({
  components: {
    MHeader
  }
})
export default class MHeaderEditTitle extends mixins(Vue) {
  @Prop()
  value!: T & IHasUpdatePartial<T, {}>;

  @Prop()
  breadCrumbs!: IBreadcrumb[];

  @Prop()
  subtitle!: string;

  @Prop()
  alerts!: IAlert[];

  @Prop()
  chips!: IChips[];

  @Prop({ default: () => [] })
  actions!: IAction[];

  @Prop()
  loading!: false;

  @Prop()
  c!: string;

  @Prop({ default: "title" })
  prop!: string;

  isLoadingTitle = false;

  isEditingTitle = false;

  editTitleCopy = this.value[this.prop] ?? "";

  startEditingTitle() {
    this.editTitleCopy = this.value[this.prop] ?? "";
    this.isEditingTitle = true;
  }

  cancelEditTitle() {
    this.isEditingTitle = false;
    this.editTitleCopy = this.value.title;
  }

  async saveEditTitle() {
    this.isLoadingTitle = true;
    await this.value
      .updatePartial({
        [this.prop]: this.editTitleCopy
      })
      .catch(handleError);
    this.editTitleCopy = this.value.title;

    this.isLoadingTitle = false;
    this.isEditingTitle = false;
  }
}
